import React, { useEffect } from "react";
import { Router } from "@reach/router";
import Login from "./views/Login";
import { useContext } from "react";
import { AuthContext } from "./context/AuthContext";
import Modal from "./components/common/Modal";
import SuccessAlert from "./components/common/SuccessAlert";
import ErrorAlert from "./components/common/ErrorAlert";
import Loading from "./views/Loading";
import moment from "moment";
import AsideOffCanvas from "./components/global/AsideOffCanvas";
import BranchPanel from "./views/BranchPanel";
import { AppConfigContext } from "./context/AppConfigContext";

const Main = () => {
  
  const { user, userLoggedIn } = useContext(AuthContext);
  const { getAppConfig } = useContext(AppConfigContext);

  useEffect(() => {
    userLoggedIn();
    getAppConfig();
    moment.updateLocale("es", {
      weekdays: "Lun_Mar_Mie_Jue_Vie_Sab_Dom".split("_"),
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="container-fluid px-0 position-relative vh-100">
      <Router>
        <Login path="/entrar" default />
        {user !== null ? (
          <BranchPanel path="/myadmin/*" />
        ) : (
          <Loading path="/myadmin/*" />
        )}
      </Router>
      <Modal />
      <AsideOffCanvas />
      <SuccessAlert />
      <ErrorAlert />
    </div>
  );
};

export default Main;
